import { render, staticRenderFns } from "./Stripping.vue?vue&type=template&id=07f2c118&scoped=true"
import script from "./Stripping.vue?vue&type=script&lang=js"
export * from "./Stripping.vue?vue&type=script&lang=js"
import style0 from "./Stripping.vue?vue&type=style&index=0&id=07f2c118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f2c118",
  null
  
)

export default component.exports